module.exports = __webpack_public_path__ + "static/media/ResponPic4.20dd957d.jpg";